/**
 * SEO文脈で名前を埋め込む際にショップ店員の場合は、ニックネームの後ろに括弧書きでショップ名を含める。この時の名前を返す
 * ※ただしWEARISTAの場合はショップ店員であってもショップ名は含めない
 */
export const getUserNameForSeo = ({
  wearista = false,
  shopClerk = false,
  nickname,
  shopName,
}: {
  wearista?: boolean
  shopClerk?: boolean
  nickname: string
  shopName?: string
}): string => {
  if (wearista) {
    return nickname
  }
  if (shopClerk && shopName !== undefined) {
    return `${nickname}（${shopName}）`
  }
  return nickname
}
